import { HttpResponse } from '@angular/common/http';

export class CachedRequest<T> {
  constructor(payload: HttpResponse<T>, lifetimeHeader: string) {
    this.payload = payload;
    this.cacheLifetime = parseInt(lifetimeHeader);
    this.cachedAt = new Date();
  }

  public cachedAt: Date;
  public cacheLifetime: number;
  public payload: HttpResponse<T>;
  public get isExpired(): boolean {
    const currentDate: any = new Date();
    const cached: any = this.cachedAt;
    var differenceInSeconds = (currentDate - cached) / 1000;
    return differenceInSeconds >= this.cacheLifetime;
  }
}
